module.exports = __webpack_public_path__ + "img/company_icon_img.7e8758d2.png";